import Bootstrap     from "./application/Bootstrap.js";
import Wakelock      from "./application/Wakelock.js";
import ServiceWorker from "./application/ServiceWorker.js";
import Scale         from "./application/Scale.js";

const Application = function(global) {
    const log = global.log.getLogger("f_mtac.application");

    this.bootstrap = new Bootstrap(global);
    this.wake_lock = new Wakelock(global);
    this.service_worker = new ServiceWorker(global);
    this.scale = new Scale();

    var install_event = null;

    this.supported = (service_name) => {
        return (service_name in navigator && navigator[service_name] !== null) ? true : false;
    };

    this.install = new Promise((resolve) => {
        window.addEventListener("beforeinstallprompt", (event) => {
            // Prevent the mini-infobar from appearing on mobile
            //event.preventDefault();
            // Stash the event so it can be triggered later.
            install_event = event;
            // Update UI notify the user they can install the PWA
            //install_event.prompt();
            return install_event.userChoice.then(choiceResult => {
                if (choiceResult.outcome === "accepted") {
                    log.info("application installed");
                    resolve(true);
                } else {
                    log.warn("application not installed");
                    resolve(false);
                }
            });
        });
    });

    this.installed = new Promise(resolve => {
        window.addEventListener("appinstalled", () => {
            resolve();
        });
    });

    this.is_installed = () => {
        if (navigator.standalone) {
            // Launched: Installed (iOS)
            return true;
        } else if (matchMedia("(display-mode: standalone)").matches) {
            // Launched: Installed
            return true;
        } else {
            // Launched: Browser Tab
            return false;
        }
    };

    this.bootstrap.register_module({
        name: "app",
        deps: [],
        init: async () => {
            this.wake_lock.enable();
        }
    });

    this.bootstrap.register_module({
        name: "app_configuration",
        deps: ["configuration"],
        init: async () => {
            await global.configuration.add_store("app", {ku: 1, font_factor: 1});
        }
    });

    this.bootstrap.register_module({
        name: "scale",
        deps: ["app_configuration"],
        init: async () => {
            this.scale.wb = null;
            this.scale.ku = global.configuration.app.ku;
            this.scale.font_size = global.configuration.app.font_size;
            window.addEventListener("resize", () => {
                this.scale.wb = null;
            });
        }
    });

    this.bootstrap.register_module({
        name: "service_worker",
        deps: ["app"],
        init: async () => {
            this.service_worker.register();
        }
    });
};

export default Application;
